/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Share_Card_VolumeInputs */

const en_us2_workout_share_card_volume = /** @type {(inputs: Workout_Share_Card_VolumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volume`)
};

const pt_br2_workout_share_card_volume = /** @type {(inputs: Workout_Share_Card_VolumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volume`)
};

const es_419_workout_share_card_volume = /** @type {(inputs: Workout_Share_Card_VolumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volumen`)
};

const pt_pt2_workout_share_card_volume = /** @type {(inputs: Workout_Share_Card_VolumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volume`)
};

const fr_fr2_workout_share_card_volume = /** @type {(inputs: Workout_Share_Card_VolumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volume`)
};

const de_de2_workout_share_card_volume = /** @type {(inputs: Workout_Share_Card_VolumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volumen`)
};

const it_it2_workout_share_card_volume = /** @type {(inputs: Workout_Share_Card_VolumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volume`)
};

/**
* | output |
* | --- |
* | "Volume" |
*
* @param {Workout_Share_Card_VolumeInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_share_card_volume = /** @type {((inputs?: Workout_Share_Card_VolumeInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Share_Card_VolumeInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_share_card_volume(inputs)
	if (locale === "es-419") return es_419_workout_share_card_volume(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_share_card_volume(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_share_card_volume(inputs)
	if (locale === "de-DE") return de_de2_workout_share_card_volume(inputs)
	if (locale === "it-IT") return it_it2_workout_share_card_volume(inputs)
	return en_us2_workout_share_card_volume(inputs)
});
export { workout_share_card_volume as "workout-share.card_volume" }